export enum DbThingType {
    Group = 1,
    Instance = 2,
    Npc = 3,
    Object = 4,
    Quest = 5,
    Vendor = 6,
    Event = 7,
    Item = 8,
}
